module.exports = __webpack_public_path__ + "img/partner10.9d33547f.png";